export default {"src":"/_next/static/media/sports2.88b32e14.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};